import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Row, Column } from 'components/shared/Layout';
import FormattedCurrency from 'components/ui/FormattedCurrency';

import { insuranceShape } from 'constants/propTypes';
import { VerticalLine, StyledHr, StyledPrice, LastColumn } from '../Extras.styles';

const Insurance = ({ insurance, children }) => (
  <div key={insurance.policyNumber} data-cy="extras-insurance" data-testid="extras-insurance">
    <Row>
      <Column span={4}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="extras.passenger" />
          </strong>
          <div>
            {insurance.passenger.firstName} {insurance.passenger.lastName}
          </div>
        </VerticalLine>
      </Column>
      <Column span={3}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="extras.insurance.date" />
          </strong>
          <div>{insurance.date}</div>
        </VerticalLine>
      </Column>
      <Column span={3}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="extras.insurance.policyNumber" />
          </strong>
          <div>{insurance.policyNumber}</div>
        </VerticalLine>
      </Column>
      <Column span={6}>
        <LastColumn>
          <strong>
            <FormattedMessage id="extras.insurance.description" />
          </strong>
          <div>{insurance.description}</div>
        </LastColumn>
      </Column>
    </Row>
    <StyledHr />
    <Row span={16}>
      <StyledPrice>
        <FormattedMessage id="extras.total" />: <FormattedCurrency currency={insurance.currency} amount={insurance.price} />
      </StyledPrice>
    </Row>

    {children}
  </div>
);

Insurance.propTypes = {
  insurance: insuranceShape,
  children: PropTypes.node
};

export default Insurance;
